import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

export default function SelectCondominioPage({ gcMe }) {
  const [list, setList] = useState([]);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get('/gastos-comunes/condominios')
      .then((r) => setList(r.data))
      .catch((e) => setError(e.response?.data?.error || e.message));
  }, []);

  const pick = (id) => {
    localStorage.setItem('gc_condominio_id', id);
    const rol = gcMe?.membresias?.find((m) => m.condominioId === id)?.rolGc;
    const soloPortal = rol === 'propietario' && !gcMe?.isSuperAdminGc;
    navigate(soloPortal ? `/c/${id}/portal` : `/c/${id}`);
  };

  return (
    <>
      <div className="page-header">
        <h2>Condominios</h2>
        <p>Elige el edificio con el que vas a trabajar.</p>
      </div>
      <div className="card">
        {error && <div className="alert alert-error">{error}</div>}
        {!list.length && !error && (
          <div className="alert alert-info">
            No tienes condominios asignados.
            {gcMe?.isSuperAdminGc ? ' Crea uno en Super admin.' : ' Pide acceso a tu administrador.'}
          </div>
        )}
        <ul className="condo-list">
          {list.map((c) => (
            <li key={c.id}>
              <button type="button" className="condo-item" onClick={() => pick(c.id)}>
                <strong>{c.nombre}</strong>
                {c.direccion ? <span>{c.direccion}</span> : <span>Sin dirección registrada</span>}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
